module.exports = __webpack_public_path__ + "img/delete.8f2e4fc0.png";